import React from "react";
import { TagCategorySectionProps } from "@/types/materialsLibrary";
import { Checkbox, Form, Grid } from "antd/lib";
import { lazyRetry } from "@/utils/helpers";
import dynamic from "next/dynamic";

const TooltipParagraph = dynamic(() => lazyRetry(() => import("@/src/components/Common/TooltipParagraph")), {
  ssr: false,
});

const { Group } = Checkbox;
const { Item } = Form;
const { useBreakpoint } = Grid;

const TagCategorySection: React.FC<TagCategorySectionProps> = ({ items = [], name, onChange }): React.JSX.Element => {
  const screens = useBreakpoint();

  return (
    <Item name={name}>
      <Group
        onChange={onChange}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {items.map((item, i) => (
          <Checkbox key={i} value={item.value.toString()}>
            <TooltipParagraph style={{ width: screens.xl ? "197px" : "264px", marginBottom: 0 }}>
              {item.label}
            </TooltipParagraph>
          </Checkbox>
        ))}
      </Group>
    </Item>
  );
};

export default TagCategorySection;
